import React from "react";

import { ReactComponent as StatusBarChecked } from 'Icons/statusbarChecked.1.svg';

const getCaptionValues = (rfq)=> {
    const returnValue = {
        rfqDetails: 5,
        // cargoInfo: 0
    };
    if(rfq.rfqDetails.name.length > 0) {
        returnValue.rfqDetails+=1;
    }
    // if(rfq.rfqDetails.serviceType > -1) {
    //     returnValue.rfqDetails+=1;
    // }
    if(rfq.rfqDetails.serviceModes.length) {
        returnValue.rfqDetails+=1;
    }
    if(rfq.rfqDetails.insuranceBy ) {
        returnValue.rfqDetails+=1;
    }

    if(rfq.cargoInfo.cargoDetails.length) {
        returnValue.rfqDetails+=1;
    }
    if(rfq.cargoInfo.packingType) {
        returnValue.rfqDetails+=1;
    }
    if(rfq.cargoInfo.handlingInstructions.length) {
        returnValue.rfqDetails+=1;
    }
    if(rfq.cargoInfo.productCategory) {
        returnValue.rfqDetails+=1;
    }
    return returnValue;
}

const getStatusBar = (noOfFieldsFilled, totalNoOfFields, selfActiveView, currentActiveView)=> {
    if(noOfFieldsFilled >= totalNoOfFields) {
        return (
            <div className="bg-success ht-8 wt-8 br-50p">

            </div>
        )
    }
    else if(noOfFieldsFilled < totalNoOfFields) {
        return (
            <div className="bg-error ht-8 wt-8 br-50p">

            </div>
        )
    }
}

const RFQStatusBar = ({rfq, activeView, setActiveView, trips}) => {
    const captionValues = getCaptionValues(rfq);
    return (
        <div className="pa ht-50 bg-theme-light col-1 ">
            <div className="container col-1 row-100 flex flex-middle flex-between">
                <div className="flex">
                    {captionValues.rfqDetails <8 &&<div className="bg-theme fs-12 fBold white-color ht-20 wt-20 br-20 flex flex-center flex-middle">
                        1
                    </div>}
                    {captionValues.rfqDetails >=8 && <StatusBarChecked />}
                    <div className="ml-10">
                        <div className="fs-14 fBold header-dark-color mb-2">RFQ Details</div>
                        <div className="flex flex-middle">
                            <div className="fs-12 mr-5 caption-color">{captionValues.rfqDetails}/20 Fields Filled</div>
                            {getStatusBar(captionValues.rfqDetails, 8)}
                        </div>
                    </div>
                </div>
                <div className="flex-1 border-status-bar ml-10 mr-10"></div>
                {
                    // <div className="flex">
                    //     {captionValues.cargoInfo <4 &&<div className="bg-theme fs-12 fBold white-color ht-20 wt-20 br-20 flex flex-center flex-middle">
                    //         2
                    //     </div>}
                    //     {captionValues.cargoInfo >=4 && <StatusBarChecked />}
                    //     <div className="ml-10">
                    //         <div className="fs-14 fBold header-dark-color mb-2">Cargo Information</div>
                    //         <div className="flex flex-middle">
                    //             <div className="fs-12 mr-5 caption-color">{captionValues.cargoInfo}/4 fields filled</div>
                    //             {getStatusBar(captionValues.cargoInfo, 4)}
                    //         </div>
                    //     </div>
                    // </div>
                
                    // <div className="flex-1 border-status-bar ml-10 mr-10"></div>
                
                    // <div className="flex flex-middle">
                    //         {!((rfq.documents && rfq.documents.length > 0) && (rfq.groups.length > 0 || rfq.transporters.length > 0 || rfq.isAllTransporters)) && <div className="bg-theme fs-12 fBold white-color ht-20 wt-20 br-20 flex flex-center flex-middle">
                    //         3
                    //         </div>}
                    //         {((rfq.documents && rfq.documents.length > 0) && (rfq.groups.length > 0 || rfq.transporters.length > 0 || rfq.isAllTransporters)) && <StatusBarChecked />}
                    //     <div className="fs-14 fBold header-dark-color mb-2 ml-10">
                    //         <div className="fs-14 fBold">Bidding and Payments</div>
                    //     </div>
                    // </div>
                    // <div className="flex-1 border-status-bar ml-10 mr-10"></div>
                    // <div className="flex flex-middle">
                    
                    //         {!((rfq.documents && rfq.documents.length > 0) && (rfq.groups.length > 0 || rfq.transporters.length > 0 || rfq.isAllTransporters)) && <div className="bg-theme fs-12 fBold white-color ht-20 wt-20 br-20 flex flex-center flex-middle">
                    //         4
                    //         </div>}
                    //         {((rfq.documents && rfq.documents.length > 0) && (rfq.groups.length > 0 || rfq.transporters.length > 0 || rfq.isAllTransporters)) && <StatusBarChecked />}
                    //     <div className="fs-14 fBold header-dark-color mb-2 ml-10">
                    //         <div className="fs-14 fBold">Transporter and docs</div>
                    //     </div>
                    // </div>
                    // <div className="flex-1 border-status-bar ml-10 mr-10"></div>
                }
                <div className="flex flex-middle">
                    {!(rfq.type !== 8 ? ((rfq.documents && rfq.documents.length > 0) && (rfq.groups.length > 0 || rfq.transporters.length > 0 || rfq.isAllTransporters)) : (rfq.documents && rfq.documents.length > 0)) && <div className="bg-theme fs-12 fBold white-color ht-20 wt-20 br-20 flex flex-center flex-middle">
                        2
                    </div>}
                    {(rfq.type !== 8 ? ((rfq.documents && rfq.documents.length > 0) && (rfq.groups.length > 0 || rfq.transporters.length > 0 || rfq.isAllTransporters)) : (rfq.documents && rfq.documents.length > 0)) && <StatusBarChecked />}
                    <div className="fs-14 fBold header-dark-color mb-2 ml-10">
                        <div className="fs-14 fBold">{rfq.type !== 8 ? 'Trip Details (Line Items)' : 'Material Details'}</div>
                    </div>
                </div>

                <div className="flex-1 border-status-bar ml-10 mr-10"></div>
                <div className="flex flex-middle">
                    {(!trips || trips.length === 0) && <div className="bg-theme fs-12 fBold white-color ht-20 wt-20 br-20 flex flex-center flex-middle">
                        3
                    </div>}
                    {(trips && trips.length > 0) && <StatusBarChecked />}
                    <div className="fs-14 fBold header-dark-color mb-2 ml-10">
                        <div className="fs-14 fBold">Preview & Submit</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RFQStatusBar;